
// @ts-nocheck
import { Component, Vue, Watch } from 'vue-property-decorator';
import SellerHeader from '@/components/Seller/SellerHeader.vue';
import { ErrorMessages } from '@/helpers/constants';
import { getAssistantData } from '@/services/seller.service';
import { userYear, eventDate, eventDateTime, isoDateToTextDate } from '@/helpers/date';
import { getMyData } from '@/services/user.service';
import _ from 'lodash';

@Component({
  components: {
    SellerHeader,
  },
})
export default class AssistantProfile extends Vue {
  eventId!: number = localStorage.getItem('selectedEvent');
  assistantId = '';
  assistant = '';
  initials = '';
  totalBills = 0;
  totalSellers = 0;
  events = [];
  public skeletonCount = [0, 1, 2];
  public loading = false;

  // TODO ver lo de vendedores. averiguar que dato iterar para obtener cantidad de vendedores

  async mounted() {
    this.assistantId = this.$route.params.id;
    try {
      this.loading = true;
      const assistantData = await getAssistantData(this.assistantId);
      this.assistant = assistantData.data.data;
      this.initials = this.assistant.fullname.charAt(0);

      const events = this.assistant.events;
      this.events = _.orderBy(events, 'initial_date', 'desc');

      const sellersArray = [];
      // Iterar eventos -> productos.ticket para obtener la sumatoria de los precios y de vendedores

      events.forEach(element => {
        const products = element.products;
        products.forEach(product => {
          this.totalBills += product.tickets[0].price_product;
          sellersArray.push(product.tickets[0].seller.id);
        });
      });
      this.totalSellers = new Set(sellersArray).size;
      this.loading = false;
    } catch (e) {
      console.log(e);
      Vue.$toast.error(ErrorMessages.COMMON);
    }
  }

  dateFormat(isoDate) {
    return isoDateToTextDate(isoDate);
  }

  getEventDateTime(date: Date) {
    return eventDateTime(date);
  }

  getEventDate(date: Date) {
    return eventDate(date);
  }

  getUserAge(date: Date) {
    return userYear(date);
  }

  getUserGender(gender: string) {
    if (gender == 'male') {
      return 'Masculino';
    } else if (gender == 'female') {
      return 'Femenino';
    } else {
      return 'Otro';
    }
  }

  goToEventDetail(id) {
    this.$router.push('/seller/assistant-profile/' + this.$route.params.id + '/event/' + id);
  }
}
